import request from '@/utils/request';

const path = 'api/v1';

const consignorsList = data => request({
  url: `${path}/consignors`,
  method: 'Get',
  params: data,
});

export {
  consignorsList,
};
